/* jshint esversion: 6 */

import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/loginVue';
import ClassSoftware from '@/views/trainClass/personalCenter/learnCenter/classSoftware';
import ClassSoftwareIndex from '@/views/trainClass/personalCenter/learnCenter';
import personalApp from '@/views/trainClass/personalCenter/app';
import Message from '@/views/trainClass/personalCenter/message';
import PersonalInfo from '@/views/trainClass/personalCenter/accountInfo/personaInfo';
import AccountSafty from '@/views/trainClass/personalCenter/accountInfo/accountSafty';
import ChangePwd from '@/views/trainClass/personalCenter/accountInfo/changePwd';
import ThroughWay from '@/views/trainClass/personalCenter/accountInfo/throughWay';
import SetPa from '@/views/trainClass/personalCenter/accountInfo/setPa';
import SetEma from '@/views/trainClass/personalCenter/accountInfo/setEma';
import SetPho from '@/views/trainClass/personalCenter/accountInfo/setPho';
import SetQue from '@/views/trainClass/personalCenter/accountInfo/setQue';
import ChangeWay from '@/views/trainClass/personalCenter/accountInfo/changeInfo';
import StudyLog from '@/views/trainClass/personalCenter/accountInfo/studyLog';
import Ranking from '@/views/trainClass/personalCenter/accountInfo/ranking';
import findPass from '@/views/findPass/app';
import CheckIdInfo from '@/views/findPass/checkIdInfo';
import FindPassword from '@/views/findPass/findPassword';
import ChangePassword from '@/views/findPass/changePassword';
import ChangeDone from '@/views/findPass/changeDone';
import ContactAdmin from '@/views/findPass/contactAdmin';

import saftySetting from '@/views/saftySetting/app';
import SystemPrompt from '@/views/saftySetting/systemPrompt';
import BasicInfo from '@/views/saftySetting/basicInfo';
import SetInfo from '@/views/saftySetting/setInfo';
import SetSuccess from '@/views/saftySetting/setSuccess';
import SetPassword from '@/views/saftySetting/setPassword';
import ChangeSuccess from '@/views/saftySetting/changeSuccess';

import Err404 from '@/views/Err404';

import config from '@/utils/config';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      // component: Login,
      redirect: '/login'
    },
    {
      name: 'Login',
      path: '/login',
      component: Login
    },
    {
      name: 'saftySetting',
      path: '/SaftySetting/BasicInfo',
      component: saftySetting,
      children: [
        {
          name: 'SystemPrompt',
          path: '/SaftySetting/SystemPrompt',
          component: SystemPrompt
        },
        {
          name: 'BasicInfo',
          path: '/SaftySetting/BasicInfo',
          component: BasicInfo
        },
        {
          name: 'SetInfo',
          path: '/SaftySetting/SetInfo',
          component: SetInfo
        },
        {
          name: 'SetSuccess',
          path: '/SaftySetting/SetSuccess',
          component: SetSuccess
        },
        {
          name: 'SetPassword',
          path: '/SaftySetting/SetPassword',
          component: SetPassword
        },
        {
          name: 'ChangeSuccess',
          path: '/SaftySetting/ChangeSuccess',
          component: ChangeSuccess
        }
      ]
    },
    {
      name: 'findPass',
      path: '/FindPass/CheckIdInfo',
      component: findPass,
      children: [
        {
          name: 'CheckIdInfo',
          path: '/FindPass/CheckIdInfo',
          component: CheckIdInfo
        },
        {
          name: 'FindPassword',
          path: '/FindPass/FindPassword',
          component: FindPassword
        },
        {
          name: 'ChangePassword',
          path: '/FindPass/ChangePassword',
          component: ChangePassword
        },
        {
          name: 'ChangeDone',
          path: '/FindPass/ChangeDone',
          component: ChangeDone
        },
        {
          name: 'ContactAdmin',
          path: '/FindPass/ContactAdmin',
          component: ContactAdmin
        }
      ]
    },

    {
      name: 'personalCenter',
      path: '/trainClass/personalCenter/learnCenter/learnTrain',

      component: personalApp,
      children: [
        {
          name: 'mockResultStudent',
          path: '/trainClass/personalCenter/mockResultStudent',
          meta: {
            index: '13'
          },
          component: () =>
            import('@/views/trainClass/personalCenter/mockResult')
        },
        {
          name: 'mockResultTeacher',
          path: '/EducationManagemant/mockResultTeacher',
          redirect: '/EducationManagemant/mockResultTeacher/home',
          meta: {
            index: '14'
          },
          component: () =>
            import('@/views/EducationManagemant/mockTest/index'),
          children: [
            {
              name: 'home',
              path: '/EducationManagemant/mockResultTeacher',
              component: () =>
                import(
                  '@/views/EducationManagemant/mockTest/home'
                ),
              meta: {
                index: '14'
              }
            },
            {
              name: 'detail',
              path:
                '/EducationManagemant/mockResultTeacher/detail',
              component: () =>
                import(
                  '@/views/trainClass/personalCenter/mockResult'
                ),
              meta: {
                index: '14'
              }
            }
          ]
        },
        {
          name: 'mockTest',
          path: '/trainClass/personalCenter/learnCenter/mockTest',
          meta: {
            index: '12'
          },
          component: () =>
            import(
              '@/views/trainClass/personalCenter/learnCenter/classSoftware'
            )
        },
        {
          name: 'ClassSoftware',
          path:
            '/trainClass/personalCenter/learnCenter/classSoftware',
          redirect:
            '/trainClass/personalCenter/learnCenter/classSoftware/home',
          component: ClassSoftwareIndex,
          meta: {
            index: '1'
          },
          children: [
            {
              name: 'trainCourseHome',
              path:
                '/trainClass/personalCenter/learnCenter/classSoftware/home',
              meta: {
                index: '1',
                keepAlive: true
              },
              component: () =>
                import(
                  '@/views/trainClass/personalCenter/learnCenter/home'
                )
            },
            {
              name: 'trainCourseInfo',
              path:
                '/trainClass/personalCenter/learnCenter/classSoftware/trainCourseInfo',
              meta: {
                index: '1',
                keepAlive: false
              },
              component: () =>
                import(
                  '@/views/trainClass/personalCenter/learnCenter/classSoftware'
                )
            }
          ]
        },
        {
          name: 'trainClassManage',
          path: '/EducationManagemant/trainClassManage',
          alias:
            '/trainClass/personalCenter/learnCenter/classSoftware',
          redirect: '/EducationManagemant/trainClassManage/home',
          component: () =>
            import(
              '@/views/EducationManagemant/trainClassManage/index'
            ),
          children: [
            {
              name: 'trainClassManage',
              path: '/EducationManagemant/trainClassManage/home',
              component: () =>
                import(
                  '@/views/EducationManagemant/trainClassManage/home'
                ),
              meta: {
                index: '11'
              }
            },
            {
              name: 'trainClassManage',
              path:
                '/EducationManagemant/trainClassManage/detail',
              component: () =>
                import(
                  '@/views/EducationManagemant/trainClassManage/detail'
                ),
              meta: {
                index: '11'
              }
            },
            {
              name: 'trainClassManage',
              path:
                '/EducationManagemant/trainClassManage/statistics',
              component: () =>
                import(
                  '@/views/EducationManagemant/trainClassManage/statistics'
                ),
              meta: {
                index: '11'
              }
            }
          ],
          meta: {
            index: '11'
          }
        },
        // 自研题阅卷
        {
          name: 'selfQuestionMarking',
          path: '/EducationManagemant/selfQuestionMarking',
          redirect: '/EducationManagemant/selfQuestionMarking/home',
          meta: {
            index: '15'
          },
          component: () =>
            import(
              '@/views/EducationManagemant/selfQuestionMarking/index'
            ),
          children: [
            {
              name: 'selfQuestionMarkingHome',
              path:
                '/EducationManagemant/selfQuestionMarking/home',
              component: () =>
                import(
                  '@/views/EducationManagemant/selfQuestionMarking/home'
                ),
              meta: {
                index: '15'
              }
            },
            {
              name: 'selfQuestionMarking',
              path:
                '/EducationManagemant/selfQuestionMarking/paperInspection',
              component: () =>
                import(
                  '@/views/EducationManagemant/selfQuestionMarking/paperInspection'
                ),
              meta: {
                index: '15'
              }
            }
          ]
        },
        // 自研在线学习
        {
          name: 'onlineStudy',
          path: '/EducationManagemant/onlineStudy',
          redirect: '/EducationManagemant/onlineStudy/home',
          meta: {
            index: '16'
          },
          component: () =>
            import('@/views/EducationManagemant/onlineStudy/index'),
          children: [
            {
              name: 'onlineStudyHome',
              path: '/EducationManagemant/onlineStudy/home',
              component: () =>
                import(
                  '@/views/EducationManagemant/onlineStudy/home'
                ),
              meta: {
                index: '16'
              }
            },
            {
              name: 'onlineStudyCatalog',
              path:
                '/EducationManagemant/onlineStudy/lessonCatalog',
              component: () =>
                import(
                  '@/views/EducationManagemant/onlineStudy/lessonCatalog'
                ),
              meta: {
                index: '16'
              }
            },
            {
              name: 'onlineStudyDetail',
              path:
                '/EducationManagemant/onlineStudy/catalogDetail',
              component: () =>
                import(
                  '@/views/EducationManagemant/onlineStudy/catalogDetail'
                ),
              meta: {
                index: '16'
              }
            }
          ]
        },
        // 自研在线考试
        {
          name: 'onlineExam',
          path: '/EducationManagemant/onlineExam',
          component: () =>
            import('@/views/EducationManagemant/onlineExam/index'),
          meta: {
            index: '17'
          }
        },
        {
          name: 'Exam',
          path: '/EducationManagemant/onlineExam/exam',
          component: () =>
            import('@/views/EducationManagemant/onlineExam/exam'),
          meta: {
            index: '17'
          }
        },
        {
          name: 'onlineExamResultDetail',
          path: '/EducationManagemant/onlineExam/resultDetail',
          component: () =>
            import(
              '@/views/EducationManagemant/onlineExam/resultDetail'
            ),
          meta: {
            index: '17'
          }
        },
        // 自研错题库
        {
          name: 'ErrQuestion',
          path: '/EducationManagemant/errQuestion',
          redirect: '/EducationManagemant/errQuestion/home',
          meta: {
            index: '16'
          },
          component: () =>
            import('@/views/EducationManagemant/errQuestionBank/index'),
          children: [
            {
              name: 'ErrQuestion',
              path: '/EducationManagemant/errQuestion/home',
              component: () =>
                import('@/views/EducationManagemant/errQuestionBank/home'),
              meta: {
                index: '18'
              }
            },
            {
              name: 'ErrBank',
              path: '/EducationManagemant/errQuestion/errBank',
              component: () =>
                import('@/views/EducationManagemant/errQuestionBank/errBank'),
              meta: {
                index: '18'
              }
            }
          ]
        },
        {
          name: 'PersonalInfo',
          path: '/trainClass/personalCenter/accountInfo/personalInfo',
          component: PersonalInfo,
          meta: {
            index: '5'
          }
        },
        // {
        //   name: 'AccountSafty',
        //   path: '/trainClass/personalCenter/accountInfo/accountSafty',
        //   component: AccountSafty,
        //   meta: {
        //     index: '7'
        //   }
        // },
        {
          name: 'ChangePwd',
          path: '/trainClass/personalCenter/accountInfo/changePwd',
          component: ChangePwd,
          meta: {
            index: '7'
          }
        },
        {
          name: 'StudyLog',
          path: '/trainClass/personalCenter/accountInfo/studyLog',
          component: StudyLog,
          meta: {
            index: '8'
          }
        },
        {
          name: 'ThroughWay',
          path:
            '/trainClass/personalCenter/accountInfo/throughWay/:way',
          component: ThroughWay
        },
        {
          name: 'SetPa',
          path: '/trainClass/personalCenter/accountInfo/setPa',
          component: SetPa
        },
        {
          name: 'SetEma',
          path: '/trainClass/personalCenter/accountInfo/setEma',
          component: SetEma
        },
        {
          name: 'SetPho',
          path: '/trainClass/personalCenter/accountInfo/setPho',
          component: SetPho
        },
        {
          name: 'SetQue',
          path: '/trainClass/personalCenter/accountInfo/setQue',
          component: SetQue
        },
        {
          name: 'Ranking',
          path: '/trainClass/personalCenter/accountInfo/ranking',
          component: Ranking,
          meta: {
            index: '9'
          }
        },
        {
          name: 'ChangeWay',
          path:
            '/trainClass/personalCenter/accountInfo/changeInfo/:changeWay',
          component: ChangeWay,
          meta: {
            index: '7'
          }
        },

        {
          name: 'Message',
          path: '/trainClass/personalCenter/message',
          component: Message,
          meta: {
            index: '10'
          }
        }
      ]
    },

    {
      path: '/Err404',
      component: Err404,
      hidden: true
    },
    {
      path: '*',
      redirect: '/Err404',
      hidden: true
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js